import { Grid, Typography, useTheme } from "@mui/material";
import Header from "components/Header/Header";
import AppButton from "components/StyledComponents/AppButton";
import { createBreadcrumbs } from "helpers/breadCrumbs";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { superAdminAction } from 'redux/superAdmin/slice/user';
import { appActions } from 'redux/app/slice/app';
import AdminUserListTable from './adminUserListTable/index';
import { getAdminUsersListAction } from "redux/superAdmin/actions";
import { useSelector } from 'react-redux';
import UploadAddUserModalAdmin from "./components/UploadAddUserModalAdmin";



const AdminUser = () => {
  const theme = useTheme();
  const [breadCrumbs, setBreadcrumbs] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch()
  const [modalOpen, setModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const { adminUserList } = useSelector((store) => store?.superAdmin?.adminUsers || [])
  const { searchField, employeeClass, userStatus, date, restaurant, orderBy } = useSelector((store) => store?.app?.filters || "")


  const handleClose = () => {
    setModalOpen(false);
  };

  useEffect(() => {
  }, [adminUserList])

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs());
    dispatch(superAdminAction.setFrontlineUserData({}));
    dispatch(appActions.initFilters());
    dispatch(appActions.setInitDate(""));
    dispatch(appActions.setOrderBy("-hire_date"))
  }, []);


  useEffect(() => {
    dispatch(getAdminUsersListAction({
      page: currentPage,
      search: searchField,
      role: employeeClass,
      status: userStatus?.toLowerCase(),
      restaurant: restaurant,
      hire_date: date,
      orderBy: orderBy
    }))
  }, [currentPage, searchField, employeeClass, userStatus, restaurant, date, orderBy])
  useEffect(() => {
    setCurrentPage(1)
  }, [searchField, employeeClass, userStatus, restaurant, date, orderBy])

  return (
    <>
      <UploadAddUserModalAdmin
        open={modalOpen}
        onClose={handleClose}></UploadAddUserModalAdmin>
      <Grid container>
        <Grid item xs={12}>
          <Header title="User List" breadCrumbs={breadCrumbs}>
            <Typography
              variant="body1Regular"
              onClick={() => setModalOpen(true)}
              sx={{
                color: theme.palette.secondary.main,
                textDecoration: "underline",
                margin: "13px 50px",
                cursor: "pointer",
                textUnderlineOffset: "2px"
              }}>
              + Add Bulk User
            </Typography>
            <AppButton
              onClick={() =>
                history.push("/super-admin/dashboard/admin-user-list/add-admin-user")
              }
              sx={{ padding: "13px 80px" }}>
              + Add New User
            </AppButton>
          </Header>
        </Grid>
      </Grid>
      <Container style={{ minWidth: "100%" }}>
        {/* <Row>
          <Col lg="12" className="d-flex justify-content-end mb-4 mt-2 p-0">
            <AppButton style={{ padding: "14px 20px", backgroundColor: theme.palette.secondary.main }}>
              Send Email
            </AppButton>
          </Col>
        </Row> */}

        <Row>
          <Col lg="12" className="p-0">
            <AdminUserListTable
              setPage={setCurrentPage}
              currentPage={currentPage}
              totalPage={adminUserList?.totalPages}
              rows={adminUserList?.data || []}
              columns={columns}></AdminUserListTable>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AdminUser;
const columns = [
  {
    id: "id",
    label: "S.No",
    minWidth: 100,
    align: "center"
  },
  {
    id: "Name",
    label: "Name",
    minWidth: 200
  },
  {
    id: "User Type",
    label: "User Type",
    align: "center",
    minWidth: 170
  },
  {
    id: "Role",
    label: "Role ",
    align: "center",
    minWidth: 170
  },
  {
    id: "Restaurant Name",
    label: "Restaurant Name",
    align: "center",
    minWidth: 170
  },
  // {
  //   id: "Hire Date",
  //   label: "Hire Date",
  //   align: "center",
  //   isSorting: true,
  //   minWidth: 100
  // },
  {
    id: "Status",
    label: "Status",
    align: "center",
    minWidth: 170
  },
  {
    id: "Action",
    label: "Action",
    align: "center",
    minWidth: 100
  }
];

